import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { site } from "@/config/site";
import { BillingStatusPill } from "@/features/billing/components/BillingStatusPill";
import { useBillingStatus } from "@/features/billing/hooks/useBillingStatus";
import { getAccountId } from "@/lib/auth/account";
import {
  connectedAccountTitle,
  formatConnectedAccount,
} from "@/lib/auth/formatConnectedAccount";
import { LiveBadge } from "@/features/layout/components/LiveBadge";
import { PLAN_TOPBAR_LOADING } from "@/features/billing/planCopy";

export function TopBar() {
  const { status, isLoading } = useBillingStatus();
  const accountId = getAccountId();
  const accountLabel = formatConnectedAccount(accountId);

  const billingPill = (() => {
    if (isLoading || !status) {
      return <span className="balance-pill">{PLAN_TOPBAR_LOADING}</span>;
    }
    return <BillingStatusPill status={status} />;
  })();

  return (
    <header className="app-top-bar flex flex-wrap items-center justify-between gap-4 border-b border-[var(--border-soft)] bg-[var(--surface)] px-6 py-3.5 text-sm">
      <div className="flex flex-wrap items-center gap-3">
        <span
          className="balance-pill max-w-full font-mono text-[0.8125rem] break-all"
          title={connectedAccountTitle(accountId)}
        >
          {accountLabel}
        </span>
        {billingPill}
        <LiveBadge />
      </div>
      <div className="flex items-center gap-4">
        <Link to={ROUTES.help} className="link-quiet text-sm">
          Help & Support
        </Link>
        <a
          href={site.stripeDashboardUrl}
          target="_blank"
          rel="noreferrer"
          className="link-quiet text-sm"
        >
          Stripe Dashboard
        </a>
      </div>
    </header>
  );
}
